import { isDev, createLogger } from "../utilities/debug.js";
class AttributeTypeError extends TypeError {
  constructor(attributeName, expectedType, actualValue, componentName) {
    const prefix = componentName ? `[${componentName}] ` : "";
    super(
      `${prefix}Attribute "${attributeName}" expected type "${expectedType}" but received "${actualValue}"`
    );
    this.name = "AttributeTypeError";
    this.attributeName = attributeName;
    this.expectedType = expectedType;
    this.actualValue = actualValue;
    this.componentName = componentName;
  }
}
class AttributeValidationError extends Error {
  constructor(attributeName, constraint, componentName) {
    const prefix = componentName ? `[${componentName}] ` : "";
    super(
      `${prefix}Attribute "${attributeName}" failed validation: ${constraint}`
    );
    this.name = "AttributeValidationError";
    this.attributeName = attributeName;
    this.constraint = constraint;
    this.componentName = componentName;
  }
}
function devWarning(message) {
  if (isDev()) {
    console.warn(`[UMD-DS]`, message);
  }
}
function reportAttributeErrors(componentName, errors) {
  if (errors.length === 0) return;
  const logger = createLogger(componentName);
  if (errors.length === 1) {
    logger.error(errors[0].message);
    return;
  }
  logger.group(`${errors.length} attribute errors`);
  for (const err of errors) {
    logger.error(err.message);
  }
  logger.groupEnd();
}
export {
  AttributeTypeError,
  AttributeValidationError,
  devWarning,
  reportAttributeErrors
};
//# sourceMappingURL=errors.js.map
